import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { DefinitionDataSection, ReportDefinition } from '../../../types';
import { useDefinitionContext } from '../../contexts/DefinitionContext';
import { SectionEditor } from './SectionEditor';

export function SectionTabs() {
  const { blueprint, languages, initialDefinition } = useDefinitionContext();
  const { control } = useFormContext<ReportDefinition>();
  const formData = useWatch({ control, name: 'data' });
  const definition = formData || initialDefinition.definition;

  const language = languages[0];
  const sections = blueprint.sections || [];
  const [activeSectionId, setActiveSectionId] = useState(sections[0]?.id || null);

  // Find current tab index based on activeSectionId
  const currentTabIndex = sections.findIndex((s) => s.id === activeSectionId);
  const tabValue = currentTabIndex >= 0 ? currentTabIndex : 0;
  const blueprintSection = sections[tabValue];

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    const section = sections[newValue];

    if (section) {
      setActiveSectionId(section.id);
    }
  };

  const definitionSection = definition.sections.find(
    (s) => s.id === blueprintSection.id,
  ) as DefinitionDataSection;

  return (
    <Box>
      {sections.length > 1 && (
        <Tabs value={tabValue} onChange={handleTabChange}>
          {sections.map((section) => {
            const defSection = definition.sections.find((s) => s.id === section.id);
            return (
              <Tab
                key={section.id}
                label={defSection?.label[language] || section.label[language]}
              />
            );
          })}
        </Tabs>
      )}

      <SectionEditor blueprintSection={blueprintSection} definitionSection={definitionSection} />
    </Box>
  );
}
